"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importDefault(require("react"));
var EventBus_1 = __importDefault(require("../EventBus"));
var InjectedComponent_1 = __importDefault(require("./InjectedComponent"));
/*****
  DO NOT REQUIRE HEAVY DEPENDENCIES HERE
  Avoid requiring lodash here
  We're trying to keep these files as js-vanilla as possible
  To keep `lite.bundle.js` as small as possible
*****/
var InjectedModuleView = /** @class */ (function (_super) {
    __extends(InjectedModuleView, _super);
    function InjectedModuleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isMounted = false;
        _this.state = {
            moduleComponent: undefined,
            moduleName: undefined,
            componentName: undefined,
            error: undefined
        };
        return _this;
    }
    InjectedModuleView.prototype.loadModule = function (modName, compName) {
        var _this = this;
        var moduleName = modName || this.props.moduleName;
        var componentName = compName || this.props.componentName;
        if (moduleName === this.state.moduleName && componentName === this.state.componentName) {
            return;
        }
        else if (!moduleName) {
            return;
        }
        this.setState({ moduleComponent: undefined, moduleName: moduleName, componentName: componentName });
        if (!window.botpress || !window.botpress[moduleName]) {
            var script_1 = document.createElement('script');
            script_1.type = 'text/javascript';
            script_1.onload = function () {
                script_1.onload = null;
                setImmediate(function () {
                    _this.setViewInState(moduleName, componentName);
                });
            };
            script_1.src = "assets/modules/".concat(moduleName, "/web/").concat(this.props.lite ? 'lite.bundle.js' : 'admin.bundle.js');
            document.getElementsByTagName('head')[0].appendChild(script_1);
        }
        else {
            this.setState({ moduleComponent: null });
            setImmediate(function () {
                _this.setViewInState(moduleName, componentName);
            });
        }
    };
    InjectedModuleView.prototype.loadModuleView = function (moduleName, isLite) {
        if (!window.botpress || !window.botpress[moduleName]) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = "assets/modules/".concat(moduleName, "/web/").concat(isLite ? 'lite.bundle.js' : 'admin.bundle.js');
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    };
    InjectedModuleView.prototype.setViewInState = function (moduleName, componentName) {
        if (!moduleName) {
            return;
        }
        var viewResolve = function () {
            var module = window.botpress && window.botpress[moduleName];
            return module && ((componentName && module[componentName]) || module['default']);
        };
        if (!this._isMounted) {
            return;
        }
        var module = viewResolve();
        if (!module) {
            this.setState({
                error: new Error("Component \"".concat(componentName, "\" doesn't exist for module \"").concat(moduleName, "\"")),
                moduleComponent: null
            });
        }
        else {
            this.setState({ moduleComponent: module, error: null });
        }
    };
    InjectedModuleView.prototype.componentDidMount = function () {
        this._isMounted = true;
        this.loadModule();
    };
    InjectedModuleView.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    InjectedModuleView.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.loadModule(nextProps.moduleName, nextProps.componentName);
    };
    InjectedModuleView.prototype.render = function () {
        var moduleComponent = this.state.moduleComponent;
        if (this.state.error) {
            console.error('Error rendering plugin', this.state.error);
            return (this.props.onNotFound && this.props.onNotFound(this.state.error)) || null;
        }
        if (!moduleComponent) {
            return null;
        }
        var bp = {
            events: EventBus_1.default.default,
            axios: axios_1.default.create({ baseURL: window.BOT_API_PATH }),
            getModuleInjector: function () { return InjectedModuleView; },
            loadModuleView: this.loadModuleView
        };
        window.botpress.injector = bp;
        var extraProps = this.props.extraProps || {};
        return react_1.default.createElement(InjectedComponent_1.default, __assign({ component: moduleComponent, name: this.props.moduleName, bp: bp }, extraProps));
    };
    return InjectedModuleView;
}(react_1.default.Component));
exports.default = InjectedModuleView;
